import React from 'react';
import { AnchorProps } from '@sls-react/components/Links/A';
import { Link } from '@sls-react/routing';
import { useSession } from '@sls-react/contexts/SessionContext';
import LoginLink from '@sls-react/components/Links/LoginLink';

type Props = AnchorProps;

const MyFeedLink: React.FC<Props> = ({ children, ...props }) => {
  const { loggedIn } = useSession();

  if (!loggedIn) {
    return (
      <LoginLink message="Log in to access your feed" {...props}>
        {children}
      </LoginLink>
    );
  }

  return (
    <Link href="/feed" passHref>
      <a {...props} rel="nofollow noindex">
        {children}
      </a>
    </Link>
  );
};

export default MyFeedLink;
